import { FilNotifications } from "../types/models/notification-course";
import { HttpClient } from "./http-client";

/**
 * Suivi des courses au back-office : la contrepartie durable de ce que le hub
 * pousse en direct.
 *
 * Les notifications poussées et celles lues ici ont exactement la même forme —
 * la cloche alimente une seule liste depuis les deux sources. Réservé aux
 * gestionnaires : l'API refuse l'accès aux autres, le client n'a rien à
 * filtrer.
 */
export class NotificationService {
  private readonly http: HttpClient;

  constructor(apiUrl: string) {
    this.http = new HttpClient(apiUrl);
  }

  /** Les notifications les plus récentes, et le compteur de non-vues de l'appelant. */
  async getFil(limite = 20, signal?: AbortSignal): Promise<FilNotifications> {
    return this.http.get<FilNotifications>(
      `/api/notifications?limite=${limite}`,
      { signal },
    );
  }

  /**
   * Avance le marque-page. Le curseur vient du client : entre le chargement du
   * fil et l'ouverture de la cloche, d'autres notifications ont pu arriver par
   * le hub, et seul lui sait lesquelles il a réellement montrées.
   */
  async marquerVues(jusquA: number): Promise<void> {
    await this.http.put(`/api/notifications/vues/${jusquA}`);
  }
}
